import { gql } from '@apollo/client';

export const ALL_INPUT_TYPES = gql`
  query AllInputTypes($inputCategoryId: ID, $interventionId: ID) {
    inputTypes: getInputTypes(inputCategoryId: $inputCategoryId, interventionId: $interventionId) {
      id
      name
    }
  }
`;
